import React from 'react';
import { Table, Avatar, Checkbox } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { feedback, border } from '../../../../ux/Tasks/configs/designTokens';

const MATCH_STYLES = {
  match: {
    color: feedback.success,
    backgroundColor: '#fff',
    border: `1px solid ${border.light}`,
  },
  noMatch: {
    color: feedback.error,
    backgroundColor: '#fff',
    border: `1px solid ${border.light}`,
  },
};

export default function TargetingLocationPreviewImportTable({ data, selectLocation }) {
  const tableColumns = [
    {
      title: 'MATCH?',
      dataIndex: 'matched',
      key: 'matched',
      width: '15%',
      render: (text, record) => {
        const { matched } = record;
        return (
          <Avatar
            style={matched ? MATCH_STYLES.match : MATCH_STYLES.noMatch}
            icon={matched ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
          />
        );
      },
    },
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',
      width: '23.33%',
      render: (text) => {
        return <div>{text}</div>;
      },
    },
    {
      title: 'SOURCE ADDRESS',
      dataIndex: 'sourceAddress',
      key: 'sourceAddress',
      width: '23.33%',
      render: (text) => {
        return <div>{text}</div>;
      },
    },
    {
      title: 'FOUND ADDRESS',
      dataIndex: 'formattedAddress',
      key: 'formattedAddress',
      width: '20%',
      render: (text, record) => {
        return (
          <div className="targeting-preview__address-cell">
            {text ? (
              text
            ) : (
              <span className="targeting-preview__no-match">
                Google could not find a corresponding address.
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: 'WARNINGS',
      dataIndex: 'errorMessage',
      key: 'errorMessage',
      width: '15%',
      render: (text) => {
        return (
          <div className="targeting-preview__warning-cell">
            {text}
          </div>
        );
      },
    },
    {
      title: 'ADD ADDRESS?',
      dataIndex: 'addAddress',
      key: 'addAddress',
      width: '15%',
      render: (text, record) => {
        return (
          <>
            {record.matched && (
              <div className="targeting-preview__checkbox-cell">
                <Checkbox
                  onChange={() => {
                    selectLocation(record.id);
                  }}
                  defaultChecked={record.matched ? true : false}
                />
              </div>
            )}
          </>
        );
      },
    },
  ];
  return (
    <Table
      pagination={false}
      columns={tableColumns}
      dataSource={data.sort((a, b) => a.id - b.id)}
      // Setting scroll causes an issue with the way the table renders. Will use when figured out
      scroll={{ y: 300 }}
      rowKey="id"
    />
  );
}
